import React from "react";
import AccountStore from "./AccountContext";

const Store: React.FC = ({ children }) => {
  return <AccountStore>{children}</AccountStore>;
};

export default Store;
